import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { withNamespaces } from 'react-i18next';

import { Loading } from 'libs/rendering/gltf/components/loading';

export const LoadingViewer = withNamespaces()(
  observer(props => {
    const { width } = props;
    const canvasWidth = width || '100%';
    return (
      <>
        <Loading
          isLayoutCentered
          visible
          noText
          canvasWidth={canvasWidth}
          paused={false}
        />
      </>
    );
  }),
);

LoadingViewer.propTypes = {
  width: PropTypes.string,
};
